import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {PermissionConfig} from 'src/app/core/constants/permission-config';
import {MatDialog} from '@angular/material/dialog';
import {Component, OnInit, Input, ViewChild, AfterViewInit, OnDestroy, ViewChildren, ElementRef} from '@angular/core';
import {MatSort, Sort} from '@angular/material/sort';
import {DataSource, SelectionModel} from '@angular/cdk/collections';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {Subscription, BehaviorSubject, Observable, merge, ReplaySubject} from 'rxjs';
import {NotificationService} from 'src/app/core/services/notification.service';
import {CommonService} from 'src/app/core/services/common.service';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {Message} from 'src/app/core/class/message';
import {tap} from 'rxjs/operators';
import {ViewPdfComponent} from 'src/app/shared/components/view-pdf/view-pdf.component';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ToastrService} from 'ngx-toastr';
import {CdkDetailRowDirective} from 'src/app/shared/directive/cdk-detail-row.directive';
import {Router, ActivatedRoute} from '@angular/router';
import {DocumentService} from 'src/app/core/services/document.service';
import {UserService} from 'src/app/core/services/user.service';
import {FormControl, NgForm} from '@angular/forms';
import {MatSelect} from '@angular/material';
import {Common, EnumDownloadMenuName} from 'src/app/core/constants/common';
import {EnumContractStatus, EnumContractUserRole} from '../../../../../../core/constants/contract';
import {EnumContractEnterpriseStatus} from '../../../../../../core/constants/contract';
import {DocumentTypeService} from '../../../../../../core/services/document-type.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ResponsiveService} from '../../../../../../core/services/responsive.service';
import {MOCK_DOC_RECEIVE} from './search-document-receive.component.mock.data';
import {MultiDownloadService} from '../../../../../../core/services/multi-download.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { WarningDataAuthenticationComponent} from 'src/app/shared/components/warning-data-authentication/warning-data-authentication.component';
import { SignAuthenticationPopupComponent } from '../../document/add-document-moha/sign-aunthentication-popup/sign-aunthentication-popup.component';
import {LotSignFlowService} from '../../../../../../core/services/lot-sign-flow.service';
import {SetupSignFlowLotComponent} from '../setup-sign-flow-lot/setup-sign-flow-lot.component';
import {SetupSignFlowLotViewComponent} from '../setup-sign-flow-lot/setup-sign-flow-lot-view/setup-sign-flow-lot-view.component';
import {SignFlowLotListComponent} from '../setup-sign-flow-lot/sign-flow-lot-list/sign-flow-lot-list.component';

@Component({
  selector: 'app-search-document-receive',
  templateUrl: './search-document-receive.component.html',
  animations: [
    trigger('detailExpand', [
      state('void', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
      state('*', style({height: '*', visibility: 'visible'})),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SearchDocumentReceiveComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  userType: any;
  enumContractStatus = EnumContractStatus;
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  isDisableNamePhoneEmail = true;
  isNotAttestedUser: boolean = false;


  constructor(
    private documentTypeService: DocumentTypeService,
    private usService: UserService,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private responsiveService: ResponsiveService,
    private downloadService: MultiDownloadService,
    private contractService: ContractService,
    private lotSignFlowService: LotSignFlowService
  ) {
    super(commonService, message);
    this.userType = localStorage.getItem('userType');
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  enumContractUserRole = EnumContractUserRole;
  user = {
    tenantId: localStorage.getItem('tenantId'),
    userName: '',
    fullName: '',
    userType: 2,
    enterpriseId: localStorage.getItem('enterpriseId'),
    phone: '',
    email: '',
    description: '',
    permissions: []
  };

  documentTypeEnterprise = {
    documentTypeId: 0,
    name: '',
    parentId: null,
    serviceTypeId: null
  };

  serviceTypes: { id: string, name: '' }[];
  isServiceTypesLoading = false;

  // displayedColumns: string[] = [
  //   'STT',
  //   'name',
  //   'allName',
  //   'status',
  //   'progressStatus',
  //   'createdEnterpriseName',
  //   'receivedTime',
  //   'action',
  // ];

  displayedColumns: string[] = [];

  columnDefinitions = [
    {def: 'select', showMobile: true, default: true},
    {def: 'STT', showMobile: true, default: true},
    {def: 'name', showMobile: true, default: true},
    {def: 'allName', showMobile: false, default: true},
    {def: 'allEmail', showMobile: false, default: true},
    {def: 'status', showMobile: false, default: true},
    {def: 'statusOriginatorReason', showMobile: false, default: false},
    {def: 'progressStatus', showMobile: false, default: true},
    {def: 'createdEnterpriseName', showMobile: false, default: true},
    {def: 'receivedTime', showMobile: false, default: true},
    {def: 'formType', showMobile: false, default: true},
    {def: 'action', showMobile: true, default: true}
  ];

  selection = new SelectionModel<string>(true, []);

  displayedChildColumns: string[] = [
    'STT',
    'name',
    'allName',
    'allEmail',
    'status',
    'progressStatus',
    'createdEnterpriseName',
    'receivedTime',
    'action',
  ];
  isBasicSearchForm = true;
  serviceTypesFilterCtrl: FormControl = new FormControl();
  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  documents = new Document();

  dataSource: DocumentDataSource;
  childDataSourceList: DocumentDataSourceKeyPair = {};

  checkFocus = true;
  paginate: Paginate;
  childPaginateList: PaginateKeyPair = {};

  oldData = this.documents;
  childOldDataList: DocumentKeyPair = {};

  isFirstLoad = true;
  isTableLoading = false;
  childIsFirstLoadList: BooleanKeyPair = {};

  childIsExexpanding: Array<string>;

  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('myForm', {static: false}) ngForm: NgForm;
  @ViewChild('statusSelect', {static: false}) statusSelect: MatSelect;
  @ViewChild('progressSelect', {static: false}) progressSelect: MatSelect;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('serviceTypeSelect', {static: false}) serviceTypeSelect: MatSelect;
  @ViewChild('signRoleSelect', {static: false}) signRoleSelect: MatSelect;

  childSortList: SortKeyPair = {};

  sortDirection = 'DESC';

  get sortDirect() {
    return this.sortDirection.toLowerCase();
  }

  childSortDirection: StringKeyPair = {};

  sortColumn = '';
  sortChildColumn: StringKeyPair = {};

  error = '';
  subscription: Subscription;
  expanded = [];
  lotId: string | null = null;
  lotSelectedRows: any[] = [];
  isProcess = false;
  percent = 0;
  signFlowTimer: any;
  openedRow: CdkDetailRowDirective;
  parentDocuments: Document[];

  isAdvancedSearch: boolean;
  isDocumentManager: boolean;

  isCustomerPerson: boolean;

  createdDateErr: string = '';
  receivedDateErr: string = '';
  finishedDateErr: string = '';

  // List all parent branches
  //parentBranches: { id: string, name: '' }[];
  // Selected model value for autocomplete
  selectedBranch: { id: string, name: '' };


  @Input() singleChildRowDetail: boolean;

  isExpansionDetailRow = (index, row) => row.hasOwnProperty('detailRow');

  ngOnInit() {
    this.dataSource = new DocumentDataSource();
    this.isCustomerPerson = this.isCustomerPersonUser();

    this.loadData();
    // if (this.userType == 1 || this.userType == 2) {
    //   this.getParentBranches();
    // }
    this.getServiceTypeByEnterprise();
    this.isDocumentManager = true;

    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.default !== false)
        .map(cd => cd.def);
    }
  }

  // Cột "Lý do từ chối" chỉ hiện khi bộ lọc trạng thái là Đã từ chối
  updateReasonColumnVisibility(){
    const reasonColumn = this.columnDefinitions.find(cd => cd.def === 'statusOriginatorReason');
    if (!reasonColumn) {
      return;
    }
    const showReasonColumn = this.documents.status === this.enumContractStatus.REJECTED;
    if (reasonColumn.default !== showReasonColumn) {
      reasonColumn.default = showReasonColumn;
      this.getDisplayedColumns();
    }
  }

  getServiceTypeByEnterprise() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.isServiceTypesLoading = true;
    this.commonService.getEnterpriseServiceType(enterpriseId).subscribe(rs => {
      this.isServiceTypesLoading = false;
      if (rs && rs.data) {
        this.serviceTypes = rs.data;
        this.filteredServiceTypes.next(rs.data.slice());
        this.documents.serviceType = parseInt(this.documents.serviceType);
      }
    }, () => this.isServiceTypesLoading = false);
  }

  toNavigate(route, params = {}) {
    let queryParams: any = {
      ...params,
      page: this.paginate.currentPage,
      pageSize: this.paginate.pageSize,
      routeLink: '/home-enterprise/search-document-receive/',
      documentType: this.documents.documentType,
      enterprise: this.documents.enterprise,
      nameOrCode: this.documents.nameOrCode,
      customerName: this.documents.customerName,
      status: this.documents.status,
      progressStatus: this.documents.progressStatus,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection
    };

    if (!this.isBasicSearchForm) {
      queryParams = {
        ...queryParams,
        serviceType: this.documents.serviceType,
        taxCode: this.documents.taxCode,
        createdEnterpriseName: this.documents.createdEnterpriseName,
        createdTimeFrom: this.documents.createdTimeFrom,
        createdTimeTo: this.documents.createdTimeTo,
        finishDateFrom: this.documents.finishDateFrom,
        finishDateTo: this.documents.finishDateTo
      };
    }

    this.router.navigate([route], {queryParams});
  }

  onUpdate(element) {
    this.getDocumentById(element.id);
  }

  checkStatusDocumentType(documentId: string, documentTypeEnterpriseId: string, callback: () => void, error: string) {
    this.documentTypeService.findById(documentTypeEnterpriseId).subscribe(rs => {
      if (rs.data.status && rs.data.relationStatus) {
        callback();
      } else {
        if (!this.toastr.findDuplicate(this.message.getMessage(error), true, true)) {
          this.toastr.error(this.message.getMessage(error));
        }
      }
    });
  }

  getDocumentById(id: string) {
    if (id) {
      this.documentService.getDocumentById(id).subscribe(rs => {
        if (rs.data.contractDTO.typeId == 0) {
          this.checkStatusDocumentType(id, rs.data.contractDTO.documentTypeEnterpriseId, () => {
            this.toNavigate('/home-enterprise/update-document/' + id);
          }, 'messages.document_stop');
        } else {
          this.toNavigate('/home-enterprise/update-document/' + id);
        }
      });
    }
  }

  onAddDocument() {
    this.toNavigate('/home-enterprise/add-document/');
  }

  onCloseAdvancedSearchForm() {
    this.isBasicSearchForm = true;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  onExpandAdvancedSearchForm() {
    this.isBasicSearchForm = false;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  isCustomerPersonUser(): boolean {
    return (localStorage.getItem('userType') === String(PermissionConfig.USER_CUSTOMER_PERSON));
  }

  // call api view file pdf
  viewPdf(id) {
    return this.commonService.getViewPdf(id).subscribe(
      rs => {
        this.showPdf(rs);
      }
    );
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    merge(this.sort.sortChange, page)
      .pipe(
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.signFlowTimer) {
      clearTimeout(this.signFlowTimer);
    }
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.downloadService.clearData();
  }

  // show dialog view file pdf
  showPdf(blob: any) {
    const file = new File([blob], null, {type: 'application/pdf'});
    this.commonService.readFile(file, (pdfSrc) => {
      this.dialog.open(ViewPdfComponent, {
        width: '70%',
        data: pdfSrc,
      });
    });
  }

  /**
   * Get parent branches for creating branch
   */
  // getParentBranches() {
  //   const enterpriseId = localStorage.getItem('enterpriseId');
  //   this.usService.getAllChild(
  //     enterpriseId
  //   ).subscribe(rs => {
  //     if (rs == null || rs.data == null) {
  //       return 0;
  //     }

  //     this.parentBranches = rs.data;
  //   });
  // }

  /**
   * Detect value changing in autocomplete input
   */
  onChangeAutoCompleted() {
    if (this.selectedBranch == null || this.selectedBranch == undefined) {
      this.oldData.enterprise = '';
    } else if (this.selectedBranch != null && this.selectedBranch != undefined) {
      /* this.ngForm.control.markAsDirty(); */
      this.oldData.enterprise = this.selectedBranch.id;
    }
  }

  // getFilterCondition(
  //   page: number, pageSize: number,
  //   enterpriseContain: string = null, documentTypeContain: any = null,
  //   nameOrCodeContain: string = null, taxCodeContain: string = null, statusContain: any = null,
  //   createDateFromContain: any = null, createDateToContain: any = null,
  //   finishDateFromContain: any = null, finishDateToContain: any = null,
  //   parentContainID: string = null): any {
  //
  //   let filterCondition: any = {
  //     enterpriseId: enterpriseContain,
  //     docsTypeId: documentTypeContain, // mau tai lieu
  //     nameOrCode: nameOrCodeContain,
  //     taxCode: taxCodeContain,
  //     status: statusContain,
  //     parentId: parentContainID,
  //     page,
  //     pageSize,
  //   };
  //
  //   if (this.isAdvancedSearch) {
  //     filterCondition = {
  //       ...filterCondition,
  //       createdTimeFrom: createDateFromContain,
  //       createdTimeTo: createDateToContain,
  //       finishDateFrom: finishDateFromContain,
  //       finishDateTo: finishDateToContain,
  //     }
  //   }
  //
  //   let sortColumn = null;
  //   let sortDirection = null;
  //
  //   if (parentContainID === null) {
  //     sortDirection = this.sortDirection;
  //     sortColumn = this.sortColumn; // is searching in parent
  //   } else {
  //     sortDirection = this.childSortDirection[parentContainID];
  //     sortColumn = this.sortChildColumn[parentContainID]; // is searching in child
  //   }
  //
  //   let column = null;
  //
  //   switch (sortColumn) {
  //     case 'name':
  //       column = {
  //         name: sortDirection
  //       };
  //       break;
  //     case 'customerName':
  //       column = {
  //         creatorName: sortDirection
  //       };
  //       break;
  //     case 'customerTaxCode':
  //       column = {
  //         creatorCertificateNo: sortDirection,
  //         creatorTaxCode: sortDirection
  //       };
  //       break;
  //     case 'createdEmail':
  //       column = {
  //         creatorEmail: sortDirection
  //       };
  //       break;
  //     case 'createdTime':
  //       column = {
  //         createdTime: sortDirection
  //       };
  //       break;
  //   }
  //
  //   filterCondition['sorts'] = column;
  //
  //   return filterCondition;
  // }

  getFilterCondition(page: number, pageSize: number, data): any {
    const {
      enterpriseContain,
      documentTypeContain,
      customerName,
      nameOrCodeContain,
      taxCode,
      statusContain,
      nameOrCode,
      receivedTimeFrom,
      receivedTimeTo,
      parentContainID,
      serviceType,
      createdEnterpriseName,
      status,
      signRole: signRole,
      nameOrEmailOrPhoneUserSign: nameOrEmailOrPhoneUserSign,
      progressStatus
    } = data;
    let filterCondition: any = {
      enterpriseId: enterpriseContain,
      docsTypeId: documentTypeContain, // mau tai lieu
      nameOrCode,
      status: status,
      parentId: parentContainID,
      customer: customerName,
      signRole: signRole,
      nameOrEmailOrPhoneUserSign: nameOrEmailOrPhoneUserSign,
      page,
      pageSize,
    };

    if (!this.isBasicSearchForm) {
      filterCondition = {
        ...filterCondition,
        receivedTimeFrom,
        receivedTimeTo,
        progressStatus,
        createdEnterpriseName,
        signRole: signRole,
        nameOrEmailOrPhoneUserSign: nameOrEmailOrPhoneUserSign
      };
    }

    let sortColumn = null;
    let sortDirection = null;

    // if (parentContainID === null) {
    //   sortDirection = this.sortDirection;
    //   sortColumn = this.sortColumn; // is searching in parent
    // } else {
    //   sortDirection = this.childSortDirection[parentContainID];
    //   sortColumn = this.sortChildColumn[parentContainID]; // is searching in child
    // }
    sortDirection = this.sortDirection || 'DESC';       // if no direction >> search by receivedTime-DESC
    sortColumn = this.sortColumn || 'receivedTime';     // if no direction >> search by receivedTime-DESC

    let column = null;
    switch (sortColumn) {
      case 'contractName':
        column = {
          contractName: sortDirection
        };
        break;
      case 'customerName':
        column = {
          creatorName: sortDirection
        };
        break;
      case 'customerTaxCode':
        column = {
          creatorCertificateNo: sortDirection,
          creatorTaxCode: sortDirection
        };
        break;
      case 'createdEmail':
        column = {
          creatorEmail: sortDirection
        };
        break;
      case 'createdTime':
        column = {
          'ce.receive_time': sortDirection
        };
        break;
    }

    filterCondition['sorts'] = column;
    // console.log(filterCondition);
    return filterCondition;
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
    } else {
      row.close = false;
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  /**
   * Get data when init
   */
  loadData(page: number = 0, pageSize: number = 10) {

    let paramEnterprise: '';
    let paramDocumentType: '';
    let paramNameOrCode: '';
    let paramTaxCode: '';
    let paramCreatedEnterpriseName: '';
    let paramStatus: '';
    let paramProgressStatus: '';
    let paramReceivedTimeFrom: any;
    let paramReceivedTimeTo: any;
    let paramCustomer: '';
    let paramSignRoles: any;
    let paramNameOrEmailOrPhoneUserSign: '';

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        paramEnterprise = params.enterprise;
        paramDocumentType = params.documentType;
        paramNameOrCode = params.nameOrCode;
        paramTaxCode = params.taxCode;
        paramCustomer = params.customer;
        paramCreatedEnterpriseName = params.createdEnterpriseName;
        paramStatus = params.status == 'countCreatorSent' ? '8' : params.status == 'countDenied' ? '6' : params.status == 'countFinish' ? '7' : params.status;
        paramProgressStatus = params.progressStatus;
        // paramStatus = Common.DOCUMENT_STATUS.indexOf(params.status) == -1 ? 'null' : params.status;
        paramReceivedTimeFrom = params.receivedTimeFrom != null ? new Date(params.receivedTimeFrom) : null;
        paramReceivedTimeTo = params.receivedTimeTo != null ? new Date(params.receivedTimeTo) : null;
        page = params.page || 0;
        pageSize = params.pageSize && params.pageSize > 0 ? params.pageSize : 10;
        this.sortColumn = params.sortColumn != null ? params.sortColumn : this.sortColumn;
        this.sortDirection = params.sortDirection != null ? params.sortDirection : this.sortDirection;
      });

    this.documents.enterprise = paramEnterprise;
    this.documents.documentType = paramDocumentType;
    this.documents.nameOrCode = paramNameOrCode;
    this.documents.taxCode = paramTaxCode;
    this.documents.customer = paramCustomer;
    this.documents.createdEnterpriseName = paramCreatedEnterpriseName;
    this.documents.status = paramStatus ? Number(paramStatus) : null;
    this.updateReasonColumnVisibility();
    this.documents.progressStatus = paramProgressStatus ? Number(paramProgressStatus) : 'null';
    this.documents.receivedTimeFrom = paramReceivedTimeFrom;
    this.documents.receivedTimeTo = paramReceivedTimeTo;
    this.documents.signRole = paramSignRoles ? Number(paramSignRoles) : null;
    this.documents.nameOrEmailOrPhoneUserSign = paramNameOrEmailOrPhoneUserSign;

    if (paramProgressStatus || paramTaxCode
      || paramReceivedTimeFrom || paramReceivedTimeTo) {
      this.isBasicSearchForm = false;
    }
    if (this.isBasicSearchForm) {
      this.documents.signRole = null;
      this.documents.nameOrEmailOrPhoneUserSign = '';
    }

    // DESC or ASC
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }

    this.isTableLoading = true;
    this.dataSource.setData([]);
    this.documentService.searchDocumentReceive(this.getFilterCondition(page, pageSize, this.documents))
      .subscribe(rs => {
        this.isTableLoading = false;
        if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
          && rs.data.totalRow != null) {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
        }

        if (rs.data && rs.data.dataRow != null) {
          this.initParent(rs);
        }
      }, () => this.isTableLoading = false);
  }

  /**
   * Reload list giữ nguyên bộ lọc hiện tại (không reset từ queryParams)
   * Dùng khi kết thúc luồng ký nội bộ để không mất signRole/nameOrEmailOrPhoneUserSign/status.
   */
  refreshData(page: number = 0, pageSize: number = 10) {
    if (this.sort.direction === 'asc') {
      this.sortDirection = 'ASC';
    } else if (this.sort.direction === 'desc') {
      this.sortDirection = 'DESC';
    }
    this.documentService.searchDocumentReceive(this.getFilterCondition(page, pageSize, this.documents))
      .subscribe(rs => {
        if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
          && rs.data.totalRow != null) {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
        }

        if (rs.data && rs.data.dataRow != null) {
          this.initParent(rs);
        }
      });
  }

  initParent(rs: any): void {
    this.parentDocuments = rs.data.dataRow;
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;

    this.parentDocuments.forEach(parent => {
      parent['STT'] = stt++;
      if (this.isCustomerPerson && parent.status == 8) {
        parent.status = 4;
      }
      this.childPaginateList[parent.id] = new Paginate();
      this.childOldDataList[parent.id] = new Document();
      this.childSortList[parent.id] = new MatSort();
    });
    console.log("parentDocuments: ", this.parentDocuments);
    this.dataSource.setData(this.parentDocuments);
    this.childIsExexpanding = [];
  }


  sortData(sort: Sort) {

    if (!sort.active || sort.direction === '') {
      this.sortColumn = '';
      this.sortDirection = '';
      return;
    }

    this.sortColumn = sort.active;
  }

  sortChildData(sort: Sort, parentID: string) {

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortChildColumn[parentID] = sort.active;
    this.childSortList[parentID].direction = sort.direction;

    this.onFilterChildData(
      this.childPaginateList[parentID].currentPage,
      this.childPaginateList[parentID].pageSize, parentID);
  }

  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {

    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }

    } else {
      this.isFirstLoad = false;
    }
    // set null for document model
    // this.oldData.nameOrCode = this.oldData.nameOrCode || null;
    // this.oldData.receivedTimeFrom = this.oldData.receivedTimeFrom || null;
    // this.oldData.receivedTimeTo = this.oldData.receivedTimeTo || null;
    // this.oldData
    // paramStatus = params.status == 'countCreatorSent' ? '8' : params.status == 'countDenied' ? '6' : params.status == 'countFinish' ? '7' : params.status;
    //     paramProgressStatus = params.progressStatus;

    // paramProgressStatus = params.progressStatus;
    //     // paramStatus = Common.DOCUMENT_STATUS.indexOf(params.status) == -1 ? 'null' : params.status;
    //     paramReceivedTimeFrom = params.receivedTimeFrom != null ? new Date(params.receivedTimeFrom) : null;
    //     paramReceivedTimeTo = params.receivedTimeTo != null ? new Date(params.receivedTimeTo) : null;
    // this.oldData.customer = this.documents.customerName || null;
    // searchDocumentReceive

    if (this.isBasicSearchForm) {
      this.documents.receivedTimeFrom = null;
      this.documents.receivedTimeTo = null;
      this.documents.progressStatus = null;
      this.documents.createdEnterpriseName = '';
      this.documents.nameOrEmailOrPhoneUserSign = null;
      this.documents.signRole = null;
      this.isDisableNamePhoneEmail = true;
    }

    this.isTableLoading = true;
    this.dataSource.setData([]);
    this.documentService.searchDocumentReceive(this.getFilterCondition(page, pageSize, this.oldData))
      .subscribe(
        rs => {
          this.isTableLoading = false;
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
          this.initParent(rs);

          if (this.isBasicSearchForm) {
            this.documents.receivedTimeFrom = null;
            this.documents.receivedTimeTo = null;
            this.documents.progressStatus = null;
            this.documents.createdEnterpriseName = '';
            this.documents.signRole = null;
            this.documents.nameOrEmailOrPhoneUserSign = '';
            this.isDisableNamePhoneEmail = true;
          }
        }
        , () => this.isTableLoading = false
      );
  }

  onFilterChildData(page: number = 0, pageSize: number = 10, parentID: string) {

    if (this.childIsFirstLoadList[parentID] === false) {
      if (this.childSortList[parentID].direction === 'asc') {
        this.childSortDirection[parentID] = 'ASC';
      } else if (this.childSortList[parentID].direction === 'desc') {
        this.childSortDirection[parentID] = 'DESC';
      }

    } else {
      this.childIsFirstLoadList[parentID] = false;
    }

    this.documentService.searchChildDocumentReceive(
      this.getFilterCondition(page, pageSize, {...this.childOldDataList[parentID], parentID}))

      .subscribe(
        rs => {
          this.childPaginateList[parentID] = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };

          let stt = this.childPaginateList[parentID].pageSize * this.childPaginateList[parentID].currentPage + 1;
          rs.data.dataRow.forEach(element => {
            element['STT'] = stt++;
            element.parentId = parentID;
          });

          this.childDataSourceList[parentID].setData(rs.data.dataRow);
        }
      );
  }

  expandedParent(parentID: string) {
    if (this.childIsExexpanding.includes(parentID)) {
      const index = this.childIsExexpanding.indexOf(parentID, 0);
      if (index > -1) {
        this.childIsExexpanding.splice(index, 1);
      }
      return;
    } else {
      this.childIsExexpanding.push(parentID);
    }
    this.childDataSourceList[parentID] = null;

    /* add child to parent to show  */
    this.parentDocuments.forEach(parentDocumentType => {
      if (parentDocumentType.id === parentID) {
        const dataFilter = {
          ...this.oldData,
          parentID
        };
        this.documentService.searchChildDocumentReceive(this.getFilterCondition(0, 10, dataFilter))
          .subscribe(rs => {
            if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
              && rs.data.totalRow != null) {
              this.childPaginateList[parentID] = {
                currentPage: rs.data.currentPage,
                pageSize: rs.data.pageSize,
                totalRow: rs.data.totalRow,
                totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
                totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
                no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
              };
            }
            if (rs.data && rs.data.dataRow != null) {

              this.childDataSourceList[parentID] = new DocumentDataSource();
              this.childDataSourceList[parentID].setData(rs.data.dataRow);

              let stt = this.childPaginateList[parentID].pageSize * this.childPaginateList[parentID].currentPage + 1;
              rs.data.dataRow.forEach(element => {
                element['STT'] = stt++;
                element.parentId = parentID;
              });

            }
          });
      }
    });
  }

  /**
   * Delete document type
   */
  delete(id: any, parentId: string = null) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.message.getMessage('messages.confirm_delete_docs_type')
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.documentService.delete(id).subscribe(() => {
          this.toastr.success(this.message.getMessage('messages.update_status_success'));
          if (this.paginate.totalRow % this.paginate.pageSize === 1) {
            if (this.paginate.currentPage - 1 < 0) {
              this.paginate.currentPage = 0;
            } else {
              this.paginate.currentPage = this.paginate.currentPage - 1;
            }
          }
          // is parent element
          if (parentId === null) {
            this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
          } else {
            this.onFilterChildData(
              this.childPaginateList[parentId].currentPage,
              this.childPaginateList[parentId].pageSize, parentId);
          }
        });
      }
    });
  }

  /**
   * Navigate to view detail document
   */
  viewDetail(element,id) {
    this.documentService.getDocumentById(id).subscribe(rs => {
        if(rs){
          if(rs.data.serviceType.isEmploymentContract){
            this.checkTindy(() => {
              let queryParams: any = {
                page: this.paginate.currentPage,
                pageSize: this.paginate.pageSize,
                routeLink: '/home-enterprise/search-document-receive/',
                documentType: this.documents.documentType,
                enterprise: this.documents.enterprise,
                nameOrCode: this.documents.nameOrCode,
                taxCode: this.documents.taxCode,
                status: this.documents.status,
                progressStatus: this.documents.progressStatus,
                sortColumn: this.sortColumn,
                sortDirection: this.sortDirection,
                goFrom: 'receive'
              };

              if (this.isAdvancedSearch) {
                queryParams = {
                  ...queryParams,
                  createdTimeFrom: this.documents.createdTimeFrom,
                  createdTimeTo: this.documents.createdTimeTo,
                  finishDateFrom: this.documents.finishDateFrom,
                  finishDateTo: this.documents.finishDateTo
                };
              }
            localStorage.setItem('progressStatus',JSON.stringify(element.progressStatus));
              this.router.navigate(['/home-enterprise/view-document-moha/' + id ], {
                queryParams
              });
            });
          }else{
            let queryParams: any = {
              page: this.paginate.currentPage,
              pageSize: this.paginate.pageSize,
              routeLink: '/home-enterprise/search-document-receive/',
              documentType: this.documents.documentType,
              enterprise: this.documents.enterprise,
              nameOrCode: this.documents.nameOrCode,
              taxCode: this.documents.taxCode,
              status: this.documents.status,
              progressStatus: this.documents.progressStatus,
              sortColumn: this.sortColumn,
              sortDirection: this.sortDirection,
              goFrom: 'receive'
            };

            if (this.isAdvancedSearch) {
              queryParams = {
                ...queryParams,
                createdTimeFrom: this.documents.createdTimeFrom,
                createdTimeTo: this.documents.createdTimeTo,
                finishDateFrom: this.documents.finishDateFrom,
                finishDateTo: this.documents.finishDateTo
              };
            }
          localStorage.setItem('progressStatus',JSON.stringify(element.progressStatus));
            this.router.navigate(['/home-enterprise/view-document/' + id ], {
              queryParams
            });
          }
        }
      });
    }

  onUpdateView(element) {
    this.getDocumentByIdView(element.id);
  }
  getDocumentByIdView(id: string) {
    if (id) {
      this.documentService.getDocumentById(id).subscribe(rs => {
        if (!rs || !rs.data) {
          return;
        }
        if (rs.data.contractDTO && rs.data.contractDTO.typeId === 0) {
          this.checkStatusDocumentType(id, rs.data.contractDTO.documentTypeEnterpriseId, () => {
            this.toNavigate('/home-enterprise/update-document/' + id, {goFrom: 'mine', typeUpdate: true});
          }, 'messages.document_stop');
        } else {
          this.toNavigate('/home-enterprise/update-document/' + id, {goFrom: 'mine', typeUpdate: true});
        }
      });
    }
  }
  setupSignFlow(id) {
    let queryParams: any = {
      page: this.paginate.currentPage,
      pageSize: this.paginate.pageSize,
      routeLink: '/home-enterprise/search-document-receive/',
      documentType: this.documents.documentType,
      enterprise: this.documents.enterprise,
      nameOrCode: this.documents.nameOrCode,
      taxCode: this.documents.taxCode,
      status: this.documents.status,
      progressStatus: this.documents.progressStatus,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection,
      goFrom: 'receive'
    };

    if (this.isAdvancedSearch) {
      queryParams = {
        ...queryParams,
        createdTimeFrom: this.documents.createdTimeFrom,
        createdTimeTo: this.documents.createdTimeTo,
        finishDateFrom: this.documents.finishDateFrom,
        finishDateTo: this.documents.finishDateTo
      };
    }

    this.router.navigate(['/home-enterprise/setup-sign-flow-receive/' + id], {
      queryParams
    });
  }

  /**
   * Open PDF By Browser
   */
  openPDFByBrowser(documentData: any) {
    if (documentData.id) {
      this.documentService.downloadFileZip(documentData.id).subscribe(res => {
        const blobUrl = URL.createObjectURL(res);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = documentData.name + '.zip';
        a.click();
      });
    }
  }

  multiDownload() {
    this.downloadService.setData({
      contractIds: this.selection.selected,
      menuContract: EnumDownloadMenuName.SEARCH_DOCUMENT_RECEIVE,
    });
  }

  /**
   * Setup internal signing flow for multiple selected documents (lot/batch).
   * Chỉ áp dụng cho các HĐ/VB đang ở trạng thái "Đang xử lý".
   * Mở popup danh sách HĐ/VB thỏa mãn trước; user bấm "Tiếp tục" thì mở popup
   * Thiết lập luồng ký nội bộ của đơn vị để áp 1 luồng chung cho tất cả HĐ đã chọn.
   */
  setupSignFlowLot() {
    const rows = this.dataSource && this.dataSource.data
      ? this.dataSource.data.value : [];
    const selectedRows = rows.filter(item => this.selection.selected.includes(item.id));
    const validRows = selectedRows
      .filter(item => item.status === EnumContractEnterpriseStatus.PROCESSING
        && item.progressStatus === EnumContractEnterpriseStatus.WAIT_SETUP_FLOW);

    if (!validRows.length) {
      this.toastr.error(this.message.getMessage('messages.no_document_wait_setup_flow'), '', {enableHtml: true});
      return;
    }

    const listDialogRef = this.dialog.open(SignFlowLotListComponent, {
      width: '70%',
      data: {
        contracts: selectedRows
      }
    });

    listDialogRef.afterClosed().subscribe((lotSelectedRows: any[]) => {
      if (!lotSelectedRows || !lotSelectedRows.length) {
        return;
      }
      const lotContractIds = lotSelectedRows.map((item: any) => item.id);

      this.lotSignFlowService.setData({
        contractIds: lotContractIds,
        menuContract: EnumDownloadMenuName.SEARCH_DOCUMENT_RECEIVE,
      });
      this.lotSelectedRows = lotSelectedRows;

      const dialogRef = this.dialog.open(SetupSignFlowLotComponent, {
        width: '70%',
        data: {
          contractIds: lotContractIds,
          contracts: lotSelectedRows
        }
      });

      dialogRef.afterClosed().subscribe(lotId => {
        if (lotId) {
          this.startSignFlowTracking(lotId);
        } else {
          this.refreshData(this.paginate.currentPage, this.paginate.pageSize);
        }
      });
    });
  }

  startSignFlowTracking(lotId: string) {
    this.lotId = lotId;
    this.isProcess = true;
    this.percent = 0;
    this.openSignFlowView();
    this.pollSignFlowProgress();
  }

  pollSignFlowProgress() {
    if (!this.lotId) {
      return;
    }
    this.documentService.signContractFlowInfo(this.lotId).subscribe(res => {
      if (this.lotId && res && res.data && res.data.lotDetails) {
        const total = res.data.lotDetails.length;
        const done = res.data.lotDetails.filter((e: any) =>
          e.status === 'done' || e.status === 'DONE' || e.status === 'error' || e.status === 'ERROR'
          || e.status === 'cancel' || e.status === 'CANCEL'
        ).length;
        this.percent = total ? Math.round(done / total * 100) : 0;
        if (this.percent >= 100) {
          this.isProcess = false;
          this.lotId = null;
          this.toastr.success(this.message.getMessage('messages.setup_signing_flow_receiver'));
          this.refreshData(this.paginate.currentPage, this.paginate.pageSize);
          return;
        }
      }
      this.signFlowTimer = setTimeout(() => this.pollSignFlowProgress(), 3000);
    });
  }

  openSignFlowView() {
    if (!this.lotId) {
      return;
    }
    this.dialog.open(SetupSignFlowLotViewComponent, {
      width: '70%',
      data: {
        contracts: this.lotSelectedRows,
        lotId: this.lotId
      }
    });
  }

  advancedSearch() {

    if (this.isAdvancedSearch) {
      this.turnOffAdvancedSearch();
    }

    this.isAdvancedSearch = !this.isAdvancedSearch;

    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  turnOffAdvancedSearch() {
    this.oldData.createdTime = null;
    this.oldData.finishDate = null;
  }

  onClickBtnFilter() {
    this.oldData = this.documents;
    this.updateReasonColumnVisibility();
    this.addColumnTable();
    // if (!((this.documents.signRole == null || this.documents.signRole == 'null' ) || this.documents.nameOrEmailOrPhoneUserSign == null) ) {
    //   if (this.columnDefinitions.length < 10) {
    //     const action =  this.columnDefinitions.pop();
    //     this.columnDefinitions.push(
    //       { def: "userSign", showMobile: false }
    //     )
    //     this.columnDefinitions.push(
    //       { def: "role", showMobile: false }
    //     )
    //     this.columnDefinitions.push(action);
    //     this.getDisplayedColumns();
    //   }
    //
    // } else {
    //   if (this.columnDefinitions.length > 10) {
    //     const action =  this.columnDefinitions.pop();
    //     this.columnDefinitions.pop()
    //     this.columnDefinitions.pop()
    //     this.columnDefinitions.push(action);
    //     this.getDisplayedColumns();
    //   }
    // }
  }

  addColumnTable() {
    if (this.isBasicSearchForm) {
      if (this.columnDefinitions.length > 12) {
        const action = this.columnDefinitions.pop();
        this.columnDefinitions.pop();
        this.columnDefinitions.pop();
        this.columnDefinitions.push(action);
        this.getDisplayedColumns();
      }
    } else {
      if (!((this.documents.signRole == null || this.documents.signRole == 'null') || this.documents.nameOrEmailOrPhoneUserSign == null) && !this.isBasicSearchForm) {
        if (this.columnDefinitions.length < 13) {
          const action = this.columnDefinitions.pop();
          this.columnDefinitions.push(
            {def: 'userSign', showMobile: false, default: true}
          );
          this.columnDefinitions.push(
            {def: 'role', showMobile: false, default: true}
          );
          this.columnDefinitions.push(action);
          this.getDisplayedColumns();
        }

      } else {
        if (this.columnDefinitions.length > 12) {
          const action = this.columnDefinitions.pop();
          this.columnDefinitions.pop();
          this.columnDefinitions.pop();
          this.columnDefinitions.push(action);
          this.getDisplayedColumns();
        }
      }
    }
    this.onFilterData(0, this.paginate.pageSize);
  }

  signRoleChanged(data: any) {

    if (this.documents.signRole === null || this.documents.signRole === 'null') {
      this.documents.nameOrEmailOrPhoneUserSign = null;
      this.documents.signRole = null;
      this.isDisableNamePhoneEmail = true;
    } else {
      this.isDisableNamePhoneEmail = false;
    }
    this.ngForm.control.markAllAsTouched();
  }

  closeExpandCollapse() {
    document.getElementById('noSpanTable').click();
  }

  isAllSelected() {
    const selecteds = this.selection.selected;
    const dataSourceIds = this.dataSource.data.value.map(d => d.id);
    const intersectionArr = dataSourceIds.filter(select => selecteds.includes(select));
    return intersectionArr.length === dataSourceIds.length;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    const dataSourceIds = this.dataSource.data.value.map(ds => ds.id);
    this.isAllSelected() ?
      this.selection.deselect(...dataSourceIds) :
      this.selection.select(...dataSourceIds);
  }

  getFormType(formType: string){
    if(formType == 'CONTRACT'){
      return this.message.getMessage('contract_terminate.contract')
    } else if (formType == 'CONTRACT_TERMINATION') {
      return this.message.getMessage('contract_terminate.terminate')
    } else if (formType === 'CONTRACT_APPENDIX') {
      return this.message.getMessage('add_document_moha.employment_contract_addendum')
    }
    else {
      return ''
    }
  }

  checkTindy(callback?: () => void){
    this.contractService.checkTindyUser().subscribe(ref => {
      if(!ref.success){
        this.toastr.error(ref.message);
        return;
      }
      if(ref.data == 0 || ref.data == 2 ){
         //Popup anthention data
          let message = "";
         if(ref.data == 2){
         message = this.message.getMessage('notifyTindy.notify');
         }else if(ref.data == 0){
         message = this.message.getMessage('notifyTindy.notify_2')
         }
        const confirmDialog = this.dialog.open(WarningDataAuthenticationComponent, {
        width: '469px',
        height: '348px',
        data: {
          message
        }
         });
         confirmDialog.afterClosed().subscribe(ref => {
          if (ref) {
            this.dialog.open(SignAuthenticationPopupComponent, {
            panelClass: 'sign-authentication',
            width: '791px',
            height: 'auto',
            data: {
              message
            }
          });
          }
       });
      }else if(ref.data == 1){
        if(callback) callback();
      }
    })
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}

export class Document {
  stt?: string;
  STT?: number;
  id: string;
  name: string;
  code: string;
  description: string;
  types: any;
  documentType: any;
  enterprise: string;
  status: any;
  createdTime: string;
  finishDate: string;
  createdUser: string;
  taxCode: string;
  email: string;
  createdPhone: string;
  parentId: string;
  createdEmail: string;
  customer: string;
  customerName: string;
  customerTaxCode: string;
  customerCertificateNo: string;
  serviceType: any;
  nameOrCode: string;
  createdTimeFrom: string;
  createdTimeTo: string;
  finishDateFrom: string;
  finishDateTo: string;
  receivedTimeFrom: string;
  receivedTimeTo: string;
  createdEnterpriseName: string;
  progressStatus: any;
  signRole: any;
  nameOrEmailOrPhoneUserSign: string;

  // 1 chưa được ký
  // 2 bị từ chối bởi bên nhận
  permission: number;

  // hồi sửa lại sau
  getPermission(): void {

  }
}

export class SortKeyPair {
  [key: string]: MatSort;
}

export class BooleanKeyPair {
  [key: string]: boolean;
}

export class StringKeyPair {
  [key: string]: string;
}

export class DocumentKeyPair {
  [key: string]: Document;
}

export class DocumentDataSourceKeyPair {
  [key: string]: DocumentDataSource;
}

export class PaginateKeyPair {
  [key: string]: Paginate;
}

export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  constructor() {
    super();
  }


  setData(data: Document[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}
